import type { PageExperienceFragment } from '@/features/experiences/fragments/PageExperience.generated';
import { Button, IconButton, Flex, Icon } from '@/ui';
import { CopyLinkButton } from '../CopyLinkButton';

type ActionButtonsProps = {
  experience: PageExperienceFragment;
  isEditing: boolean;
  isPending: boolean;
  error: boolean;
  fullUrl: string;
  onUpdate: () => void;
  onMouseDown: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ActionButtons = ({
  experience,
  isEditing,
  isPending,
  error,
  fullUrl,
  onUpdate,
  onMouseDown,
}: ActionButtonsProps) => {
  return (
    <Flex align="center" borderRadius="md" gap="1" px="1">
      {isEditing ? (
        <Button
          fontWeight="bold"
          isDisabled={isPending || !!error}
          size="md"
          onClick={onUpdate}
          onMouseDown={onMouseDown}
        >
          Update
        </Button>
      ) : (
        <>
          <IconButton
            aria-label="Open in new tab"
            as="a"
            bg="gray.200"
            color="currentColor"
            colorScheme="blackAlpha"
            href={fullUrl}
            icon={<Icon icon="ArrowUpRight" />}
            size="md"
            target="_blank"
            _hover={{
              bg: 'gray.300',
            }}
          />
          <CopyLinkButton experience={experience} />
        </>
      )}
    </Flex>
  );
};
